const PROFESSION_LABELS = [
  'Полевод',
  'Овощевод',
  'Астроном',
  'Зоотехник',
  'Свинарь',
  'Микробиолог',
  'Цветовод',
  'Птицевод',
  'Рыбовод',
  'Телятница',
  'Пчеловод',
  'Мастер машинного доения',
  'Инженер',
  'Техник',
  'Слесарь',
  'Диспетчер',
  'Станочник',
  'Токарь',
  'Радиомеханик',
  'Водитель',
  'Кузнец',
  'Радиомастер',
  'Газорезчик',
  'Раклист',
  'Администратор',
  'Мастер',
  'Начальник',
  'Педагог',
  'Врач',
  'Краевед',
  'Медсестра',
  'Стюардесса',
  'Продавец',
  'Официант',
  'Парикмахер',
  'Стенографист',
  'Машинистка',
  'Экономист',
  'Бухгалтер',
  'Программист',
  'Чертежник',
  'Переводчик',
  'Редактор',
  'Телеграфист',
  'Наборщик',
  'Художник',
  'Музыкант',
  'Литератор',
  'Форматист',
  'Оформлитель',
  'Дизайнер',
  'Модельер',
  'Стилист',
  'Флорист',
  'Чеканщик',
] as const

const uniqueLabels = Array.from(new Set(PROFESSION_LABELS)).sort((a, b) => a.localeCompare(b, 'ru'))

export const PROFESSION_OPTIONS = uniqueLabels.map((label) => ({ label, value: label }))
